export default __webpack_public_path__ + "static/media/flag-côte-d'ivoire.7a067489.svg";